    import config from "../../../helper/config";
    import APIHandler from "../../../handlers/APIHandler";

    export const NonAcademicService = {
        addRegUploads,
        create_reg_non_academic,
        getAll,
        getRegUploadsByStaffMember,
        deleteRegUpload,
        update,
    }
    async function addRegUploads(uploads) {
        const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: uploads,
        };
    
        const response = await fetch(
        `${config.oat_api_url}/manage/registration_b/non-academic-uploads/reg-doc-sub`,
        requestOptions
        );
        return APIHandler.handleResponse(response);
    }


    async function create_reg_non_academic(registration) {
        const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: registration,
        };
    
        const response = await fetch(
        `${config.oat_api_url}/manage/registration_b/non-academic-members/reg-add`,
        requestOptions
        );
        return APIHandler.handleResponse(response);
    }

    async function getAll(
        node_mid,
        user_table_id,
        create_user_id,
        create_user_table_id,
        staff_user_id,
        limit,
        offset,
        sortColumn,
        sortDirection,
        search_term
    ) {
        const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
        const login_user_id = sessionStorage.getItem("manage_user_id");
        const login_user_table_id = sessionStorage.getItem("table_log_id")
        const response = await fetch(
        `${config.oat_api_url}/manage/registration_b/non-academic-members/getAll/${node_mid}/${limit}/${offset}/${sortColumn}/${sortDirection}?search_term=${search_term}&non_a_id=${staff_user_id}&u_t_id=${user_table_id}&cr_u_id=${create_user_id}&cr_u_t_id=${create_user_table_id}&lg_u_id=${login_user_id}&lg_u_t_id=${login_user_table_id}`,
        requestOptions
        );
        return APIHandler.handleResponse(response);
    }

    async function getRegUploadsByStaffMember(
        user_id,
        user_table_id,
    ) {
        const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
        const response = await fetch(
        `${config.oat_api_url}/manage/registration_b/non-academic-uploads/getByUser/${user_id}/${user_table_id}`,
        requestOptions
        );
        return APIHandler.handleResponse(response);
    }
    
    async function deleteRegUpload(container_id, blob_id) {
        const requestOptions = {
        method: "DELETE",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        }
        };
    
        const response = await fetch(
        `${config.oat_api_url}/manage/registration_b/non-academic-uploads/delete/${container_id}/${blob_id}`,
        requestOptions
        );
        return APIHandler.handleResponse(response);
    }

    async function update(teacher, teacherId) {
        const requestOptions = {
        method: "PUT",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(teacher),
        };
        const response = await fetch(
        `${config.oat_api_url}/manage/registration_b/non-academic-members/update/${teacherId}`,
        requestOptions
        );
        return APIHandler.handleResponse(response);
    }
    
